module.exports = __webpack_public_path__ + "static/media/passover.33007d15.svg";